/**
 * Deutsche Banken — BLZ → BIC + Name Lookup
 *
 * Gepflegte Auswahl der ~85 meistgenutzten deutschen Banken (Großbanken,
 * Online-Banken, große Sparkassen-/Volksbanken-Verbünde, regionale
 * Schwergewichte). Für unbekannte BLZ kann der Nutzer BIC + Name manuell
 * eintragen — das BIC-Eingabefeld bleibt erreichbar.
 *
 * Quelle: Bundesbank BLZ-Verzeichnis (öffentlich) — Stand 2025-Q4.
 *
 * Abruf-API:  blzLookup(blz)     → { bic, name }  oder null
 *             ibanToBlz(iban)    → "37040044"     (8-stellige BLZ aus DE-IBAN)
 *             ibanToBank(iban)   → { bic, name, blz } oder null (alles in einem)
 */

export const GERMAN_BANKS = {
  // ---------- Großbanken / National ----------
  "10000000": { bic: "MARKDEF1100", name: "Bundesbank Berlin" },
  "10010010": { bic: "PBNKDEFFXXX", name: "Postbank Berlin" },
  "10070000": { bic: "DEUTDEBBXXX", name: "Deutsche Bank Berlin" },
  "10070024": { bic: "DEUTDEDBBER", name: "Deutsche Bank PGK Berlin" },
  "10080000": { bic: "DRESDEFF100", name: "Commerzbank Berlin" },
  "10090000": { bic: "BEVODEBBXXX", name: "Berliner Volksbank" },
  "10010424": { bic: "INGDDEFFXXX", name: "ING-DiBa" },
  "20070000": { bic: "DEUTDEHHXXX", name: "Deutsche Bank Hamburg" },
  "20080000": { bic: "DRESDEFF200", name: "Commerzbank Hamburg" },
  "20030000": { bic: "HYVEDEMM300", name: "HypoVereinsbank Hamburg" },
  "30070010": { bic: "DEUTDEDDXXX", name: "Deutsche Bank Düsseldorf" },
  "30080000": { bic: "DRESDEFF300", name: "Commerzbank Düsseldorf" },
  "37040044": { bic: "COBADEFFXXX", name: "Commerzbank Köln" },
  "37050198": { bic: "COLSDE33XXX", name: "Sparkasse KölnBonn" },
  "38040007": { bic: "COBADEFFXXX", name: "Commerzbank Bonn" },
  "50010060": { bic: "PBNKDEFFXXX", name: "Postbank Frankfurt" },
  "50050201": { bic: "HELADEF1822", name: "Frankfurter Sparkasse" },
  "50070010": { bic: "DEUTDEFFXXX", name: "Deutsche Bank Frankfurt" },
  "50080000": { bic: "DRESDEFFXXX", name: "Commerzbank Frankfurt" },
  "50105517": { bic: "INGDDEFFXXX", name: "ING-DiBa Frankfurt" },
  "60050101": { bic: "SOLADEST600", name: "BW-Bank / LBBW Stuttgart" },
  "60070024": { bic: "DEUTDESSXXX", name: "Deutsche Bank Stuttgart" },
  "60080000": { bic: "DRESDEFF600", name: "Commerzbank Stuttgart" },
  "70020270": { bic: "HYVEDEMMXXX", name: "HypoVereinsbank München" },
  "70070010": { bic: "DEUTDEMMXXX", name: "Deutsche Bank München" },
  "70080000": { bic: "DRESDEFF700", name: "Commerzbank München" },
  "70150000": { bic: "SSKMDEMMXXX", name: "Stadtsparkasse München" },

  // ---------- Direktbanken / Online ----------
  "20041111": { bic: "COBADEHDXXX", name: "Comdirect Bank" },
  "20041155": { bic: "COBADEHHXXX", name: "Comdirect Hamburg" },
  "76026000": { bic: "NORSDE71XXX", name: "Consorsbank" },
  "10110300": { bic: "SOBKDEBBXXX", name: "SolarisBank Berlin" },
  "11010100": { bic: "SOBKDEB2XXX", name: "Solaris (N26)" },
  "76011200": { bic: "DABBDEMMXXX", name: "DAB Bank / BNP Paribas" },
  "30070024": { bic: "DEUTDEDBDUE", name: "Deutsche Bank PGK Düsseldorf" },
  "37020100": { bic: "GENODED1NLD", name: "DZ Bank" },
  "20690500": { bic: "GENODEF1S11", name: "Sparda-Bank Hamburg" },
  "60090800": { bic: "GENODEF1S02", name: "Sparda-Bank Stuttgart" },
  "70090500": { bic: "GENODEF1S04", name: "Sparda-Bank München" },
  "76090500": { bic: "GENODEF1S06", name: "Sparda-Bank Nürnberg" },
  "85090000": { bic: "GENODEF1SLR", name: "Sparda-Bank Berlin" },
  "60010070": { bic: "DEUTDESSXXX", name: "Deutsche Bank Stuttgart" },

  // ---------- DKB ----------
  "12030000": { bic: "BYLADEM1001", name: "DKB Deutsche Kreditbank Berlin" },

  // ---------- Targobank ----------
  "30020900": { bic: "CMCIDEDDXXX", name: "Targobank Düsseldorf" },

  // ---------- Sparda + GLS ----------
  "43060967": { bic: "GENODEM1GLS", name: "GLS Bank Bochum" },

  // ---------- Apotheker- und Ärztebank / Spezialbanken ----------
  "30060601": { bic: "DAAEDEDDXXX", name: "Deutsche Apotheker- und Ärztebank" },
  "85070000": { bic: "DEUTDE8DXXX", name: "Deutsche Bank Dresden" },
  "85070024": { bic: "DEUTDEDBCHE", name: "Deutsche Bank PGK Dresden" },

  // ---------- Sparkassen (Auswahl) ----------
  "10050000": { bic: "BELADEBEXXX", name: "Berliner Sparkasse / Landesbank Berlin" },
  "20050550": { bic: "HASPDEHHXXX", name: "Hamburger Sparkasse (Haspa)" },
  "30050000": { bic: "WELADEDDXXX", name: "Sparkasse Düsseldorf" },
  "33050000": { bic: "WUPSDE33XXX", name: "Stadtsparkasse Wuppertal" },
  "34050000": { bic: "WELADED1MND", name: "Sparkasse Mönchengladbach" },
  "35050000": { bic: "WELADEDDXXX", name: "Sparkasse Duisburg" },
  "36050105": { bic: "SPESDE3EXXX", name: "Sparkasse Essen" },
  "39050000": { bic: "AACSDE33XXX", name: "Sparkasse Aachen" },
  "40050000": { bic: "WELADED1MST", name: "Sparkasse Münsterland Ost" },
  "44050199": { bic: "DORTDE33XXX", name: "Sparkasse Dortmund" },
  "47050195": { bic: "WELADED1PMB", name: "Sparkasse Paderborn-Detmold" },
  "55050000": { bic: "MALADE51MNZ", name: "Sparkasse Mainz" },
  "55250000": { bic: "MALADE51KRE", name: "Sparkasse Rhein-Nahe" },
  "59050000": { bic: "SAKSDE55XXX", name: "Sparkasse Saarbrücken" },
  "60050101": { bic: "SOLADEST600", name: "Landesbank Baden-Württemberg / BW-Bank" },
  "64350150": { bic: "REISDE66XXX", name: "Kreissparkasse Reutlingen" },
  "70050000": { bic: "BYLADEMMXXX", name: "Bayerische Landesbank" },
  "72050000": { bic: "BYLADEM1AUG", name: "Stadtsparkasse Augsburg" },
  "75050000": { bic: "BYLADEM1SRG", name: "Sparkasse Regensburg" },
  "76050101": { bic: "SSKNDE77XXX", name: "Sparkasse Nürnberg" },
  "80053762": { bic: "NOLADE21HAL", name: "Saalesparkasse" },
  "82050000": { bic: "HELADEF1WEM", name: "Sparkasse Mittelthüringen" },
  "85050300": { bic: "OSDDDE81XXX", name: "Ostsächsische Sparkasse Dresden" },

  // ---------- Volksbanken / Raiffeisenbanken (Auswahl) ----------
  "10090000": { bic: "BEVODEBBXXX", name: "Berliner Volksbank" },
  "20090500": { bic: "GENODEF1HH2", name: "Hamburger Volksbank" },
  "30060010": { bic: "GENODED1DKD", name: "Volksbank Düsseldorf Neuss" },
  "37060193": { bic: "GENODED1PA1", name: "Volksbank Köln Bonn" },
  "38060186": { bic: "GENODED1BRS", name: "Volksbank Bonn Rhein-Sieg" },
  "39060180": { bic: "GENODED1AAC", name: "Volksbank Aachen" },
  "40069768": { bic: "GENODEM1MHU", name: "Volksbank Münster" },
  "44160014": { bic: "GENODEM1DOR", name: "Dortmunder Volksbank" },
  "47660005": { bic: "GENODEM1PAD", name: "Volksbank Paderborn-Höxter-Detmold" },
  "50060400": { bic: "GENODEFFXXX", name: "DZ Bank Frankfurt" },
  "50190000": { bic: "FFVBDEFFXXX", name: "Frankfurter Volksbank" },
  "55090500": { bic: "GENODE51MZ2", name: "Mainzer Volksbank" },
  "60069517": { bic: "GENODES1HOH", name: "Volksbank Hohenzollern Balingen" },
  "70090100": { bic: "GENODEF1M01", name: "Münchner Bank" },
  "76090000": { bic: "GENODEF1NUE", name: "VR-Bank Nürnberg" },
  "80093574": { bic: "GENODEF1HAL", name: "Volksbank Halle" },

  // ---------- Spezialinstitute ----------
  "10130600": { bic: "DEGRDEFFXXX", name: "Quirin Privatbank" },
  "20130600": { bic: "MMWEDE5HXXX", name: "M.M.Warburg & Co" },
  "70210010": { bic: "FUBKDE71XXX", name: "Fürstlich Castell'sche Bank" },
};

const onlyDigits = (s) => String(s || "").replace(/\D/g, "");

/**
 * Extrahiert die 8-stellige Bankleitzahl aus einer DE-IBAN.
 * Layout: DE-PP-BBBBBBBB-KKKKKKKKKK
 *  - PP = Prüfziffer (2)
 *  - BBBBBBBB = Bankleitzahl (8)
 *  - K... = Konto (10)
 */
export function ibanToBlz(iban) {
  const n = String(iban || "").toUpperCase().replace(/\s+/g, "");
  if (!/^DE\d{2}/.test(n)) return null;
  const blz = n.substring(4, 12);
  return /^\d{8}$/.test(blz) ? blz : null;
}

export function blzLookup(blz) {
  const k = onlyDigits(blz);
  if (!k || k.length !== 8) return null;
  return GERMAN_BANKS[k] || null;
}

export function ibanToBank(iban) {
  const blz = ibanToBlz(iban);
  if (!blz) return null;
  const hit = blzLookup(blz);
  return hit ? { ...hit, blz } : null;
}

/**
 * Flache Liste aller Banken — sortiert nach Name. Eindeutige BIC-Einträge
 * (mehrere BLZs zur selben Filiale werden zusammengefasst).
 * Wird vom `BankAutocomplete`-Dropdown im SEPA-Formular genutzt.
 */
export const BANK_LIST = (() => {
  const seen = new Set();
  const out = [];
  for (const [blz, info] of Object.entries(GERMAN_BANKS)) {
    const key = `${info.bic}|${info.name}`;
    if (seen.has(key)) continue;
    seen.add(key);
    out.push({ bic: info.bic, name: info.name, blz });
  }
  out.sort((a, b) => a.name.localeCompare(b.name, "de"));
  return out;
})();
